import React, { useState } from "react"
import mount from "core/mount"
import Modal from "@convertkit/design/modal"
import Button from "@convertkit/design/button"
import BillingAddressForm from "app/shared/components/billing-address-form"

function BillingRequiredBanner(props) {
  const [active, setActive] = useState(false)
  const [successful, setSuccessful] = useState(false)
  const [modalTitle, setModalTitle] = useState("Update Your Billing Address")

  const closeModal = () => {
    if (successful) {
      window.location.reload()
    } else {
      setActive(false)
    }
  }

  const openModal = () => {
    setActive(true)
  }

  const handleSubmit = async () => {
    setModalTitle("Billing Address Updated")
    setSuccessful(true)
  }

  const ThankYou = () => {
    return (
      <div>
        <p>Thanks for updating your billing address!</p>
        <p className="mt-4">
          You can view or update it anytime in{" "}
          <a
            className="text-blue-500 focus:outline-none"
            href="/account_settings/billing"
          >
            billing settings
          </a>
          .
        </p>

        <div className="flex justify-end">
          <Button
            color="green"
            className="mt-8font-semibold w-32"
            onClick={() => window.location.reload()}
          >
            OK
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-row gap-8 justify-center items-center px-4">
      <div>
        <p className="text-left">
          <strong>ACTION REQUIRED:</strong> To comply with state tax laws, we
          need you to update your current billing address. We will be using this
          for billing purposes to correctly determine whether sales taxes apply.
          For more information, please review the{" "}
          <a
            href="https://help.convertkit.com/en/articles/5680679-account-billing-information-faq"
            className="text-blue-500 hover:text-gray-700"
          >
            Billing Information FAQ
          </a>
          .
        </p>
      </div>

      <div>
        <Button className="w-40" is="primary" onClick={openModal}>
          Update Address
        </Button>
      </div>

      {active && (
        <Modal label={modalTitle} onClose={closeModal}>
          {!successful && (
            <BillingAddressForm {...props} onSubmitted={handleSubmit} />
          )}

          {successful && <ThankYou />}
        </Modal>
      )}
    </div>
  )
}

export default BillingRequiredBanner

mount({ "Account.BillingRequiredBanner": BillingRequiredBanner })
